<i18n src="@/locales/models/delivery_process_provider.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/service_provider/delivery/managing/show_process.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-4">
    <h1 class="page-title">
      <i class="fa-solid fa-shopping-cart"></i>
      <span class="space-icon"></span>
      {{ $t("labels.delivery_process_providers_title") }}
    </h1>

    <div class="flex flex-row justify-end">
      <button type="button" @click.prevent="goToNewItem" class="btn-white">
        <i class="fa-solid fa-plus"></i>
        <span class="space-icon"></span>
        {{ $t("labels.new_delivery_process_provider_button") }}
      </button>
    </div>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue
        style="width: 100%; height: 620px"
        class="ag-theme-alpine"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef()"
        :rowData="deliveryProcessProviders"
      >
      </ag-grid-vue>
    </div>

    <table-paginator
      v-model="current_page"
      v-if="total_rows > rows_per_page"
      :total_rows="total_rows"
      :rows_per_page="rows_per_page"
    >
    </table-paginator>
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";

import Requester from "@/views/service_provider/requesters/delivery/managing/show_process.js";
import ManageRequester from "@/views/service_provider/requesters/delivery/managing/manage_delivery_process_providers.js";

import TableActions from "@/components/views/layout/ag_grid/TableActions.vue";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "SPDeliveryManagingShowProcessDeliveryProcessProviders",
  components: { AgGridVue, TablePaginator },
  data() {
    return {
      deliveryProcessProviders: [],
      current_page: 1,
      total_rows: 0,
      rows_per_page: 12,

      columnDefs: [
        {
          headerName: this.$t("model.delivery_process_provider.name"),
          field: "name",
          flex: 1,
        },
        {
          headerName: "",
          flex: 1,
          cellRendererSelector: (params) => {
            return {
              component: TableActions,
              params: {
                edit_label: "",
                editEvent: this.goToEditDeliveryProcessProvider,
                show_destroy: true,
                destroy_label: "",
                destroy_title: this.$t("labels.destroy_provider_button_title", {
                  provider: params.data.name,
                }),
                destroy_message: this.$t(
                  "labels.destroy_provider_button_message",
                  {
                    provider: params.data.name,
                  }
                ),
                destroy_label_confirm: this.$t(
                  "labels.destroy_provider_button_label_confirm"
                ),
                destroyEvent: this.destroy,
              },
            };
          },
        },
      ],
    };
  },
  props: {
    service_provider_id: { required: true },
    delivery_process_id: { required: true },
  },

  created() {
    this.fetchDeliveryProcessProviders();
  },

  methods: {
    fetchDeliveryProcessProviders: async function () {
      const response = await Requester.fetchDeliveryProcessProviders(
        this.service_provider_id,
        this.delivery_process_id,
        this.current_page,
        this.rows_per_page
      );
      this.total_rows = response.data.total_rows;
      this.deliveryProcessProviders = response.data.records;
    },

    destroy: async function (provider) {
      try {
        const index = this.deliveryProcessProviders.indexOf(provider);
        let response = await ManageRequester.destroy(
          this.service_provider_id,
          this.delivery_process_id,
          provider.id
        );
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.deliveryProcessProviders.splice(index, 1);
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
    },

    defaultColDef: function () {
      return {
        sortable: true,
        filter: true,
        floatingFilter: true,
      };
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.sizeToFit();
    },

    sizeToFit() {
      this.gridApi.sizeColumnsToFit({ defaultMinWidth: 150 });
    },

    goToNewItem: function () {
      this.$router.push({
        name: this.routeName("new_delivery_process_provider"),
        params: {
          service_provider_id: this.service_provider_id,
          delivery_process_id: this.delivery_process_id,
        },
      });
    },

    goToEditDeliveryProcessProvider: function (provider) {
      this.$router.push({
        name: this.routeName("edit_delivery_process_provider"),
        params: {
          service_provider_id: this.service_provider_id,
          delivery_process_id: this.delivery_process_id,
          id: provider.id,
        },
      });
    },
  },

  watch: {
    current_page: async function () {
      this.load_data = false;
      await this.fetchDeliveryProcessProviders();
      this.load_data = true;
    },
  },
};
</script>
